import "../../styles/global.scss";
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import happyKids from "../../images/reading.png";
import styles from "../../styles/login.module.scss";
import utilStyles from "../../styles/utils.module.scss";
import axios from "axios";
import { serverUrl, GOOGLE_API_KEY } from "../../helpers/utility";
import { AnimatePresence, motion } from "motion/react";
import { useState, useEffect } from "react";
import { mutate } from "swr";
import { useSearchParams } from "react-router-dom";
import GooglePlacesAutocomplete, { geocodeByAddress } from "react-google-places-autocomplete";

function LocalAuthoritySignUp() {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get("inviteToken") || searchParams.get("token");
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();
  let navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [address, setAddress] = useState(null);
  const formValues = watch();

  // Redirect to accept-invite page if token is present
  useEffect(() => {
    if (inviteToken) {
      navigate(`/accept-invite?token=${inviteToken}`);
    }
  }, [inviteToken, navigate]);

  // WARN: When editing use the ngrok domain as localhost will be blocked!
  async function onSubmit(data) {
    try {
      if (!data.terms) {
        alert(`Please accept our Terms and Conditions.`);
        return false;
      }
      if (data.username && data.companyName?.length >= 2 && data.password) {
        // Geocode the address to get lat/lng
        let lat = null;
        let lng = null;
        
        if (address?.label) {
          try {
            const geocodeResults = await geocodeByAddress(address.label);
            if (geocodeResults && geocodeResults.length > 0) {
              const location = geocodeResults[0].geometry.location;
              lat = location.lat().toFixed(2);
              lng = location.lng().toFixed(2);
            }
          } catch (geocodeError) {
            console.error(`Could not geocode address: ${geocodeError}`);
          }
        }

        const localAuthority = {
          name: data?.companyName,
          lat,
          lng,
        };

        const user = {
          firstName: data?.firstName,
          lastName: data?.lastName,
          email: data?.username,
          password: data?.password,
        };

        console.log(`Submitting partnership form...`);

        axios
          .post(`${serverUrl}/user/register/email`, { user, localAuthority })
          .then(async (response) => {
            console.log(JSON.stringify(response.data));

            // Persist to redux store, redirection then handled by componentDidUpdate (redux store update!)
            if (response && response.data && response.data.success) {
              const { user, token } = response.data;
              console.log(`--- User is: ${user?._id}`);

              localStorage.setItem("token", token);
              await mutate(`${serverUrl}/user`);
              await mutate(`${serverUrl}/location`);
              navigate(`/local-authority/dashboard`);
            } else {
              console.info(`ERR: Could not register. ${JSON.stringify(response.data)}`);
            }
          })
          .catch((error) => {
            console.error(`Unable to login, server error. ${JSON.stringify(error)}`);

            if (error.response && error.response.data && error.response.data.message) {
              alert(error.response.data.message);
            } else {
              console.log(error.response);
            }
          });
      } else {
        console.error(`Invalid form, should be impossible with validation rules.`);
      }
    } catch (err) {
      console.error(`ERR: onSubmit error. ${err}`);
    }
  }

  return (
    <>
      <Container fluid className={`no-padding no-margin container-fluid`}>
        <Row>
          <Col lg={6} xl={7} className={styles.loginMarketing}>
            <img src={happyKids} className={styles.marketingImage} />
            <h2 className={styles.marketingText}>Register as a Partner.</h2>
          </Col>

          <Col lg={6} xl={5} className={`${styles.signupArea}`}>
            <div style={{ width: "100%", maxWidth: 400, marginBottom: 15, padding: "0 15px" }}>
              <ProgressBar now={20 + step * 20} />
            </div>

            {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={styles.loginForm}
              style={{
                // Important for not overlapping the button
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div style={{ display: "flex", flexGrow: 1, width: "100%", flexDirection: "column" }}>
                <AnimatePresence mode="wait" initial={true}>
                  {step === 0 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 200 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -200 }}
                      key={`step0`}
                      transition={{ duration: 0.2, delay: 0 }}
                    >
                      <div style={{ padding: "10px 15px" }}>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                          {/*  <img src={onlineShop} style={{ width: 20, height: 20, marginRight: 10 }} /> */}
                          <h3 className={`h3`}>Local Authority Registration</h3>
                        </div>
                        <div className={"mb-3"}>
                          <p>
                            Register now as a Local Authority to get full access to bPlaced.
                            Registered users can save searches and invite other team members. No
                            payment details are required.
                          </p>
                          <p>
                            Only a <b>'.gov.uk'</b> email address will be accepted without written
                            confirmation from your local authority.
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  ) : null}

                  {step === 1 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 200 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -200 }}
                      key={`step1`}
                      transition={{ duration: 0.2, delay: 0 }}
                    >
                      <div style={{ padding: "10px 15px" }}>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                          {/*  <img src={onlineShop} style={{ width: 20, height: 20, marginRight: 10 }} /> */}
                          <h3 className={`h3`}>Local Authority Details</h3>
                        </div>
                        <div className={"mb-3"}>
                          <label htmlFor={"companyName"}>Local Authority Name</label>
                          <div style={{ fontSize: "12px", lineHeight: "16px", marginBottom: 5 }}>
                            <span style={{ marginRight: 3, marginTop: "3px" }}>
                              <i
                                className={`bi bi-info-circle`}
                                style={{
                                  fontSize: "10px",
                                  color: utilStyles.green,
                                  marginBottom: 2,
                                }}
                              ></i>
                            </span>
                            The UK based local authority name.
                          </div>
                          <input
                            {...register("companyName")}
                            className="form-control"
                            placeholder={`Stockport Council`}
                            autoFocus
                          />

                          {errors.companyName ? (
                            <div className="error">{errors.companyName.message.toString()}</div>
                          ) : null}
                        </div>
                      </div>
                    </motion.div>
                  ) : null}

                  {step === 2 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 200 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -200 }}
                      transition={{ duration: 0.2, delay: 0 }}
                      key={`step2`}
                    >
                      <div style={{ padding: "10px 15px" }}>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                          <h3 className={`h3`}>Office Address</h3>
                        </div>
                        <div className={"mb-3"}>
                          <label htmlFor={"address"}>Local Authority Address</label>
                          <div style={{ fontSize: "12px", lineHeight: "16px", marginBottom: 5 }}>
                            <span style={{ marginRight: 3, marginTop: "3px" }}>
                              <i
                                className={`bi bi-info-circle`}
                                style={{
                                  fontSize: "10px",
                                  color: utilStyles.green,
                                  marginBottom: 2,
                                }}
                              ></i>
                            </span>
                            Start typing your address and select from the suggestions.
                          </div>
                          <GooglePlacesAutocomplete
                            apiKey={GOOGLE_API_KEY}
                            selectProps={{
                              value: address,
                              onChange: setAddress,
                              placeholder: "Enter your office address...",
                              isClearable: true,
                              styles: {
                                control: (provided) => ({
                                  ...provided,
                                  border: "1px solid #ced4da",
                                  borderRadius: "6px",
                                  minHeight: "38px",
                                  boxShadow: "none",
                                  "&:hover": {
                                    borderColor: "#006260",
                                  },
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  fontSize: "14px",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  fontSize: "14px",
                                  color: "#6c757d",
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  fontSize: "14px",
                                }),
                              },
                            }}
                            autocompletionRequest={{
                              componentRestrictions: {
                                country: ["gb"],
                              },
                            }}
                          />
                          {errors.address ? (
                            <div className="error">{errors.address.message.toString()}</div>
                          ) : null}
                        </div>
                      </div>
                    </motion.div>
                  ) : null}

                  {step === 3 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 200 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -200 }}
                      transition={{ duration: 0.2, delay: 0 }}
                      key={`step3`}
                    >
                      <div style={{ padding: "10px 15px" }}>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                          {/*   <img src={you} style={{ width: 20, height: 20, marginRight: 10 }} /> */}
                          <h3 className={`h3`}>About You</h3>
                        </div>

                        <div className={"mb-3"}>
                          <label htmlFor={"firstName"}>First name</label>
                          <input {...register("firstName")} className="form-control" />
                        </div>

                        <div className={"mb-3"}>
                          <label htmlFor={"lastName"}>Last name</label>
                          <input {...register("lastName")} className="form-control" />
                        </div>

                        <div className={"mb-3"}>
                          <label htmlFor={"username"}>Email address</label>
                          <input {...register("username")} className="form-control" />
                        </div>

                        <div className={"mb-3"}>
                          <label htmlFor={"password"}>Password</label>
                          <div style={{ fontSize: "12px", lineHeight: "16px", marginBottom: 5 }}>
                            <span style={{ marginRight: 3, marginTop: "3px" }}>
                              <i
                                className={`bi bi-info-circle`}
                                style={{
                                  fontSize: "10px",
                                  color: utilStyles.green,
                                  marginBottom: 2,
                                }}
                              ></i>
                            </span>
                            Minimum 6 characters.
                          </div>
                          <input
                            {...register("password")}
                            type="password"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </motion.div>
                  ) : null}

                  {step === 4 ? (
                    <div style={{ padding: "10px 15px" }}>
                      <div style={{ display: "flex", flexDirection: "row", marginBottom: 3 }}>
                        {/*   <img src={you} style={{ width: 20, height: 20, marginRight: 10 }} /> */}
                        <h3 className={`h3`}>Terms and Conditions</h3>
                      </div>

                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ligula odio,
                        imperdiet.
                      </p>

                      <div className={"mb-3"}>
                        <Form.Check // prettier-ignore
                          type={`checkbox`}
                          id={`partner-terms-checkbox`}
                          label={
                            <span>
                              I agree to the{" "}
                              <a href={"/#/terms"} target="_blank" rel="noopener noreferrer">
                                bPlaced terms and conditions.
                              </a>
                            </span>
                          }
                          {...register("terms")}
                        />
                      </div>
                    </div>
                  ) : null}
                </AnimatePresence>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "0px 5px",
                  flexBasis: 50,
                }}
              >
                <input
                  className="btn btn-primary form-control"
                  type="submit"
                  value={step === 0 ? `START` : step === 4 ? `REGISTER` : `CONTINUE`}
                  onClick={(event) => {
                    // Cannot rely on 'errors' due to input being dynamically added/removed for animation

                    if (step < 4) {
                      clearErrors();
                      let hasErrors = false;

                      if (
                        step === 1 &&
                        (typeof formValues.companyName === "undefined" ||
                          formValues.companyName?.length < 3)
                      ) {
                        setError("companyName", {
                          type: "custom",
                          message: "Please enter the Local Authority name.",
                        });
                        hasErrors = true;
                      }

                      if (step === 2 && !address) {
                        setError("address", {
                          type: "custom",
                          message: "Please select your office address.",
                        });
                        hasErrors = true;
                      }

                      if (
                        step === 3 &&
                        (typeof formValues.firstName === "undefined" ||
                          formValues.firstName?.length < 3)
                      ) {
                        setError("firstName", {
                          type: "custom",
                          message: "Enter your first name.",
                        });
                        hasErrors = true;
                      }

                      if (hasErrors) {
                        event.preventDefault();
                        return false;
                      }

                      if (step === 4 && errors.terms) {
                        event.preventDefault();
                        return false;
                      }

                      setStep(step + 1);
                      event.preventDefault();
                    } else {
                      // Submit flow
                    }
                  }}
                />
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LocalAuthoritySignUp;
